import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { Link } from "@/libraries/design/components";

import {
    ContentBlock,
    OneLinkProps
} from "../../../../components/wpl/content-block/src";
import { Row } from "../../../../libraries/wpl/foundations/src/index";

/**
 * @deprecated - Please use @/libraries/design/patterns/logos instead
 */
export interface InlineLogoProps {
    src: string;
    alt: string;
    link?: string;
    width?: string;
}

/**
 * @deprecated - Please use @/libraries/design/patterns/logos instead
 */
export interface PatternCTAMobileProps {
    inlineLogos: InlineLogoProps[];
    headerText?: string;
    bodyText?: string;
    eyebrowText?: string;
    footNoteText?: string;
    ctaProps?: OneLinkProps;
    className?: string;
    linkPosition?: "top" | "bottom";
}

const ConditionalLogo = (props: {
    alt: string;
    src: string;
    link?: string;
    width?: string;
}) => {
    if (props.link) {
        return (
            <a href={props.link} className="logoblock logo-linked">
                {/* eslint-disable-next-line no-restricted-syntax */}
                <img
                    src={props.src}
                    alt={props.alt}
                    width={props.width}
                    loading="lazy"
                />
            </a>
        );
    }
    return (
        // eslint-disable-next-line no-restricted-syntax
        <img
            className="logoblock logo-plain"
            src={props.src}
            alt={props.alt}
            width={props.width}
            loading="lazy"
        />
    );
};

/**
 * @deprecated - Please use @/libraries/design/patterns/logos instead
 */
export const PatternLogos = ({
    inlineLogos,
    headerText,
    bodyText,
    className,
    eyebrowText,
    footNoteText,
    ctaProps,
    linkPosition = "top"
}: PatternCTAMobileProps) => {
    if (inlineLogos.length < 4 || inlineLogos.length > 12) {
        throw new Error("Minimum 4 logos required, maximum 12");
    }

    return (
        <div
            className={className}
            css={css({
                "padding": "64px 0",
                "textAlign": "center",
                [media.only.sm]: {
                    padding: "48px 0"
                },
                [media.below.sm]: {
                    padding: "32px 0"
                },
                // Tech debt: Adding this disable to unblock commits for GWP-2646

                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                ".footnote-text": {
                    fontSize: "0.625rem",
                    textAlign: "left",
                    margin: "30px 0 0"
                }
            })}
        >
            {headerText ? (
                <Row layout="10">
                    <ContentBlock
                        isCentered={true}
                        headerText={headerText}
                        headerType="h2"
                        eyebrowText={eyebrowText}
                        bodyText={bodyText}
                        ctaProps={
                            linkPosition == "top" && ctaProps?.primaryLinkProps
                                ? ctaProps
                                : undefined
                        }
                    />
                </Row>
            ) : null}

            <Row>
                <div
                    className={`logos-content lgth length-${inlineLogos.length}`}
                >
                    {inlineLogos.map((inlineLogo, index) => (
                        <ConditionalLogo
                            key={index}
                            alt={inlineLogo.alt}
                            src={inlineLogo.src}
                            link={inlineLogo.link}
                            width={inlineLogo.width}
                        />
                    ))}
                </div>
            </Row>

            {footNoteText ? (
                <Row>
                    <p className="footnote-text">{footNoteText}</p>
                </Row>
            ) : null}

            {linkPosition == "bottom" && ctaProps?.primaryLinkProps ? (
                <Row>
                    <div style={{ textAlign: "center" }}>
                        <Link {...ctaProps.primaryLinkProps} />
                    </div>
                </Row>
            ) : null}
        </div>
    );
};
